angular.module('app').directive('apMessageAttachment', ['aprgettext','PatientSettingsService',
    function(gettext,PatientSettingsService) {
        'use strict';

        return {
            restrict: 'E',
            templateUrl: '/app/views/directives/apMessageAttachment.html',
            scope: {
                // Use '@' for one way binding.  String value is returned.
                // Use '=' for two way binding.  An object is returned.
                // Use '&' for a method.
                attachmentDtoList: '=attachmentDtoList'

            },

            controller: function($scope) {

                var featureList = PatientSettingsService.getPatientFeatures();
                $scope.maxNumberFiles = featureList.PatientMessageAttachment.FileAttachmentConfig.NumberOfFilesThatCanBeAttached;

                $scope.attachmentDtoList = [];

                $scope.selectDocumentModel = {
                    selectedFileName: $scope.selectedFileName,
                    selectedFileContents: $scope.selectedFileContents,
                    selectedMimeType: $scope.selectedMimeType,
                    validationMessage: $scope.validationMessage
                };

            $scope.$watch('selectDocumentModel.selectedFileContents', function(newval, oldval) {

                if (newval) {

                    if (newval !== oldval) {

                        var newAttachment = true;
                        $.each($scope.attachmentDtoList, function(i, obj) {
                            if (obj.Data === newval) {
                                newAttachment = false;
                                return false;
                            }
                        });


                    if (newAttachment) {
                        if($scope.attachmentDtoList.length < $scope.maxNumberFiles){
                        $scope.attachmentDtoList.push({
                            Data: $scope.selectDocumentModel.selectedFileContents.split(',')[1],
                            FileName: $scope.selectDocumentModel.selectedFileName,
                            MimeType: $scope.selectDocumentModel.selectedMimeType,
                            Extension: $scope.selectDocumentModel.selectedFileName.split('.')[1]
                        });
                        }
                        else{
                            $scope.selectDocumentModel.validationMessage = gettext('Maximum of ') + $scope.maxNumberFiles + gettext(' attachments can be selected per message. ' + 'Please send this message and create another one to send additional files.');
                        }
                    }

                    }
                }

            }, true);


            $scope.remove = function remove(attachment) {
                $.each($scope.attachmentDtoList, function(i) {
                    if ($scope.attachmentDtoList[i].Data === attachment.Data) {
                        $scope.attachmentDtoList.splice(i, 1);
                        $scope.selectDocumentModel.selectedFileContents = '';
                        $scope.selectDocumentModel.selectedFileName = '';
                        $scope.selectDocumentModel.selectedFileContents = '';
                        $scope.selectDocumentModel.selectedFileContents = '';
                        $scope.selectDocumentModel.selectedMimeType = '';
                        return false;
                    }
                });
            };

        }
    };
  }
]
);